(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('digitalWallet', digitalWallet);

    /* @ngInject */
    function digitalWallet() {
        var directive = {
            bindToController: true,
            templateUrl: "digital-wallet.tpl",
            controller: digitalWalletCtrl,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                paymentMethod: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            window.paymentMethodName = 'wallet';
            scope.$root.loadPaymentScript();
        }
    }
    /* @ngInject */
    function digitalWalletCtrl($scope) {
    }
})();